export const AdobeConstantsAscensionSchedule = {
  open_modal: 'schedule online ascension modal',
  close: 'schedule online ascension modal:close',
  call: 'schedule online ascension modal:call',
  schedule_online: 'schedule online ascension modal:schedule online',
  location: 'body:schedule online modal',
};
